import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import bizApi from "@/lib/businessApi";
import { useBiz } from "@/lib/businessI18n";
import { cardCls, formatChf } from "./ui";

export default function Reports() {
  const { t } = useBiz();
  const [data, setData] = useState(null);

  useEffect(() => {
    bizApi.get("/reports").then((r) => setData(r.data)).catch(() => setData({}));
  }, []);

  if (!data) return <div className="flex justify-center py-16"><Loader2 className="h-5 w-5 animate-spin text-miles" /></div>;

  const kpis = [
    [t("reports.missions"), data.missions],
    [t("reports.completed"), data.completed],
    [t("reports.cancelled"), data.cancelled],
    [t("reports.spend"), formatChf(data.spend)],
    [t("reports.avg"), formatChf(data.avg_value)],
    [t("reports.airport"), data.airport_transfers],
    [t("reports.hours"), `${data.hours_booked} h`],
    [t("reports.guests"), data.guests_transported],
    [t("reports.luggage"), data.luggage_missions],
    [t("reports.commission"), formatChf(data.commission_earned)],
  ];

  return (
    <div data-testid="reports-view">
      <h1 className="text-2xl font-bold tracking-tight text-ink">{t("reports.title")}</h1>
      <div className="mt-5 grid grid-cols-2 gap-3 lg:grid-cols-5" data-testid="reports-kpis">
        {kpis.map(([label, value]) => (
          <div key={label} className={`${cardCls} p-4`}>
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate/70">{label}</p>
            <p className="mt-1 text-lg font-bold text-ink">{value}</p>
          </div>
        ))}
      </div>
      <section className={`${cardCls} mt-4 p-5`} data-testid="reports-by-type">
        <h2 className="text-sm font-bold text-ink">{t("reports.by_type")}</h2>
        <div className="mt-3 space-y-2">
          {Object.entries(data.by_type || {}).filter(([, v]) => v > 0).map(([type, count]) => (
            <div key={type} className="flex items-center gap-3" data-testid={`report-type-${type}`}>
              <span className="w-40 text-xs text-slate">{t(`type.${type}`)}</span>
              <div className="h-2 flex-1 rounded-full bg-ink/[0.05]">
                <div className="h-2 rounded-full bg-miles" style={{ width: `${Math.min(100, (count / (data.missions || 1)) * 100)}%` }} />
              </div>
              <span className="w-8 text-right font-mono text-xs font-semibold text-ink">{count}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
